import React, { useLayoutEffect, useState } from "react"
import { StructuredText } from "react-datocms"

import {
  OffsetGrid,
  Container,
  Eyebrow,
  Heading,
  Body,
  ContentSide,
  JobSide,
  JobTitle,
  JobDepartment,
  JobLocation,
  JobCard,
  JobInfo,
} from "../../../styles/Components/SingleInstance/JobsOffsetGrid"
import Button from "../../Button"

const GREENHOUSE_JOBS_URL =
  "https://boards-api.greenhouse.io/v1/boards/clickatell18/jobs?content=true"

const JobsOffsetGrid = ({ component }) => {
  const heading = component?.heading
  const eyebrow = component?.eyebrow
  const callToAction = component?.singleinsBody?.links[0]
  const body = component?.singleinsBody

  const [jobs, setJobs] = useState()

  const formatJobs = (job) => {
    const jobObj = {
      country: job?.offices[0]?.location,
      department: job?.departments[0]?.name,
      ...job,
    }

    return jobObj
  }

  const fetchJobs = async () => {
    try {
      const response = await fetch(GREENHOUSE_JOBS_URL)
      const processedResponse = await response.json()
      const listOfJobs = processedResponse?.jobs
      const formattedJobs = []
      listOfJobs.forEach((job) => {
        const formattedJob = formatJobs(job)
        formattedJobs.push(formattedJob)
      })
      setJobs(formattedJobs.slice(0, 3))
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err)
    }
  }

  useLayoutEffect(() => {
    fetchJobs()
  }, [])

  return (
    <OffsetGrid>
      <Container>
        <ContentSide>
          {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
          {heading && <Heading>{heading}</Heading>}
          {body && (
            <Body>
              <StructuredText
                data={body}
                renderInlineRecord={() => {}}
                renderLinkToRecord={() => {}}
              />
            </Body>
          )}
          {callToAction && (
            <Button isWithArrow newtab link={callToAction?.url}>
              {callToAction?.label}
            </Button>
          )}
        </ContentSide>
        <JobSide>
          {jobs &&
            jobs.map((job) => (
              <JobCard key={job?.id}>
                <JobInfo>
                  <JobTitle>{job?.title}</JobTitle>
                  <JobDepartment>{job?.department}</JobDepartment>
                  {job?.offices[0] && (
                    <JobLocation>
                      {job?.offices[0]?.name}, {job?.offices[0]?.location}
                    </JobLocation>
                  )}
                </JobInfo>
                <Button link={job?.absolute_url} newtab variant="light-blue">
                  View More
                </Button>
              </JobCard>
            ))}
        </JobSide>
      </Container>
    </OffsetGrid>
  )
}

export default JobsOffsetGrid
